import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, Card, Typography } from 'antd';
import { Container } from '@/ui';
import { useDocumentSections } from '@/features/constructorDocuments/hooks';
import { Space } from '@/features/constructorDocuments/styled';

export const DocumentSectionList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data, isLoading } = useDocumentSections();

  return (
    <>
      <Container $marginBottom={30}>
        <Typography.Title level={4}>{t('Documents list')}</Typography.Title>
      </Container>

      {isLoading && <div>{t('Loading')}...</div>}

      {data?.map((section, index) => (
        <Card key={index} size='small' title={section.type} style={{ marginBottom: '10px' }}>
          {section.name && <Typography.Paragraph>{section.name}</Typography.Paragraph>}

          <Button onClick={() => navigate(`/constructorDocuments/${section.id}`)} type='primary'>
            Edit
          </Button>
        </Card>
      ))}
    </>
  );
};
